import React from 'react';
import { Table, Column } from './ui/Table';
import { BadgeCheck, Ban } from 'lucide-react';
export interface Product {
  id: string;
  code: string;
  name: string;
  status: 'active' | 'inactive';
  category: string;
  lastUpdated: string;
}
interface ProductTableProps {
  products: Product[];
  onProductClick: (product: Product) => void;
}
export function ProductTable({
  products,
  onProductClick
}: ProductTableProps) {
  const columns: Column<Product>[] = [{
    key: 'id',
    label: 'Product ID'
  }, {
    key: 'code',
    label: 'Product Code'
  }, {
    key: 'name',
    label: 'Product Name',
    render: item => <span className="font-medium text-gray-900" data-id="element-1002">{item.name}</span>
  }, {
    key: 'category',
    label: 'Category'
  }, {
    key: 'status',
    label: 'Status',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-1003">
          {item.status === 'active' ? <BadgeCheck className="w-3 h-3 mr-1" data-id="element-1004" /> : <Ban className="w-3 h-3 mr-1" data-id="element-1005" />}
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
  }, {
    key: 'lastUpdated',
    label: 'Last Updated'
  }];
  return <Table columns={columns} data={products} onRowClick={onProductClick} keyExtractor={item => item.id} data-id="element-1006" />;
}